import request from "@/utils/server.js";
// 首页模块
// 获取官网后台首页数据
export function getWxgo_authAPI(params) {
  return request({
    url: "/wx/callback",
    method: "get",
    params,
  });
}
// 获取企业官网后台系统页面设计模块左侧导航栏和左侧组件库数据
export function getCompanyRoutersAPI(params) {
  return request({
    url: "/getCompanyRouters",
    method: "get",
    params,
  });
}
